"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const dates_1 = require("../../type-checking/dates");
class TimeFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, dates_1.isTimeValue)(fieldValue);
        };
        this.getEmptyValue = () => null;
    }
}
exports.TimeFieldValueGetter = TimeFieldValueGetter;
